import { Checkbox, Form, message } from "antd";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../asset/HOMELAND_Logo.png";
import BaseFormInput from "../../components/core/input/formInput";
import {
  ButtonCore,
  PaddingDiv,
} from "../../components/core/button/buttonCore";
import { MainColor } from "../../components/core/variable/variable";

import { loginStart, loginSuccess, loginFailure } from "../../stores/authSlice";
import { LoginApi } from "../../api/login.api";
import { getUserProfile } from "../../api/user.api";
import { AppDispatch } from "../../stores";

const LoginStyle = styled.div`
  margin: 10rem auto 0;
  width: 20%;
  padding: 2rem;
  border: 2px solid ${MainColor};
  border-radius: 15px;

  h2 {
    margin-bottom: 2rem;
    text-align: center;
  }

  .forget {
    display: flex;
    justify-content: space-between;
  }
  .logo {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
  }
`;

const LoginForm = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const location = useLocation();

  const onFinish = async (values: { email: string; password: string }) => {
    try {
      dispatch(loginStart());

      // 1. Gọi API đăng nhập để lấy token
      const loginResponse = await LoginApi(values);
      const { code, data: loginData } = loginResponse?.data || {};
      if (code === 200 && loginData?.accessToken) {
        // Lưu token vào localStorage
        localStorage.setItem("token", loginData.accessToken);

        // 2. Gọi API lấy thông tin user
        const profileResponse = await getUserProfile();

        if (profileResponse?._id) {
          const userData = profileResponse;
          localStorage.setItem("user", JSON.stringify(userData));

          dispatch(
            loginSuccess({
              token: loginData.accessToken,
              user: userData,
            })
          );

          navigate("/");
        } else {
          throw new Error("Không thể lấy thông tin người dùng");
        }
      } else {
        throw new Error(
          loginResponse?.data?.message || "Sai tên đăng nhập hoặc mật khẩu"
        );
      }
    } catch (error: any) {
      console.error("Login error:", error);
      dispatch(loginFailure(error.message || "Có lỗi xảy ra khi đăng nhập"));
    }
  };

  return (
    <LoginStyle>
      <div className="form">
        <div className="logo">
          <img
            src={logo}
            alt="logo"
            style={{
              width: "150px",
              height: "90px",
            }}
          />
        </div>
        <h2>ĐĂNG NHẬP TÀI KHOẢN</h2>
        <Form onFinish={onFinish}>
          <BaseFormInput label="Email" name="email" type="input" />
          <BaseFormInput
            label="Mật khẩu"
            name="password"
            type="password"
            password="password"
          />
          <div className="forget">
            <span>
              <Checkbox /> Nhớ mật khẩu
            </span>
            <span
              className="forgot-password"
              onClick={() =>
                message.info("Chức năng quên mật khẩu đang được phát triển")
              }>
              Quên mật khẩu?
            </span>
          </div>
          <PaddingDiv />
          <div style={{ textAlign: "center" }}>
            <ButtonCore type="submit">Đăng nhập</ButtonCore>
          </div>
        </Form>
      </div>
    </LoginStyle>
  );
};

export default LoginForm;
